import { render, staticRenderFns } from "./SRCView.vue?vue&type=template&id=064a4368&"
import script from "./SRCView.vue?vue&type=script&lang=js&"
export * from "./SRCView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports